import { render, staticRenderFns } from "./ServiceBox.vue?vue&type=template&id=086ef3bd&scoped=true&lang=pug&"
import script from "./ServiceBox.vue?vue&type=script&lang=js&"
export * from "./ServiceBox.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBox.vue?vue&type=style&index=0&id=086ef3bd&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086ef3bd",
  null
  
)

export default component.exports